export enum ReplyAuthorType {
    SUPPLIER = 'SUPPLIER',
    HOST = 'HOST',
    UNKNOWN = 'UNKNOWN',
}
